function updateBGGLink() {
  var BGGUrl = "";
  var BGGName = "";
  var BGGForumUrl = "";
  if (document.getElementById("bgg-url") != null) {
    BGGUrl = document.getElementById("bgg-url").innerHTML;
    if (BGGUrl.charAt(0) == "/") {
      BGGUrl = BGGUrl.substring(1, BGGUrl.length);
    }
  }
  if (document.getElementById("bgg-forum-url") != null) {
    BGGForumUrl = document.getElementById("bgg-forum-url").innerHTML;
  }
  var BGGLink = "http://boardgamegeek.com/boardgame/" + BGGUrl;
  var BGGImageLink = "http://boardgamegeek.com/images/boardgame/" + BGGUrl + "?username=&sort=hot&date=alltime&gallery=all&tag=&licensefilter=&B1=Go";
  var BGGVideoLink = "http://boardgamegeek.com/videos/thing/" + BGGUrl + "?username=&sort=hot&date=alltime&gallery=&B1=Go";
  var BGGReviewLink = BGGForumUrl;
  
  if (document.getElementById("bgg-column") != null) {
    document.getElementById("bgg-column").innerHTML= '<b><a href="' + BGGLink + '" target="_blank">BoardGameGeek</a> (<a href="' + BGGImageLink + '" target="_blank">Images</a>, <a href="' + BGGVideoLink + '" target="_blank">Videos</a>, <a href="' + BGGReviewLink + '" target="_blank">Reviews</a>)</b>';
  }
  if (document.getElementById("bgg-row") != null) {
    document.getElementById("bgg-row").style.display = "table-row";
  }
}

// Run once the DOM is ready instead of on window 'load' (which waits for all
// images/subresources). This script is deferred, so the function is defined in time.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", updateBGGLink);
} else {
  updateBGGLink();
}
